import { gaEvent } from 'src/utils'

import { UpdateCart, parseEvent } from './utils'

/**
 * Parâmetro para {@link parseEvent}
 */
export type UpdateCartEvent = UpdateCart

/**
 * @deprecated usar function {@link ecommerceEvent} com eventName 'remove_cart', evitar o uso dessa função.
 * [TARGET]: registrar adição/atualização/remoção de produto na sacola
 *
 * [CONTEXTO]: deve ser utilizada quando um produto é adicionado/removido da sacola
 *
 * [REGRAS]:
 * - Registra 'preco-da-revendedora' na Dimension.RESELLER_PRICE do produto, caso haja tag marcada como 'Preço do Revendedor'
 * - Registra 'pronta-entrega' ou 'nao-pronta-entrega' na Dimension.PROMPT_DELIVERY do produto de acordo com a disponibilidade
 *
 * @param config - Objeto com dados do evento
 */
export const updateCartEvent = (config: UpdateCart) => {
  const baseEvent = parseEvent(config)

  gaEvent(baseEvent)
}
